import { PostContactsParamsProps } from '../AddInterface';

export const getContactDetailsInputConfig = (postContactsParams: PostContactsParamsProps) => [
    {
        name: 'email',
        value: postContactsParams?.body[0]?.email,
        errorMessage: 'enteravalidemailadress',
    },
    {
        name: 'firstname',
        value: postContactsParams?.body[0]?.firstname,
    },
    {
        name: 'lastname',
        value: postContactsParams?.body[0]?.lastname,
    },
];
